<div class="container">
    <div class="row">
        <div class="row-title">{{'dashboard.parameter_value' | stringLiterals}} <span class="required-field">*</span>
        </div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                [data]="parameterValueList" [textField]="'value'" [valueField]="'id'" [value]="selectedParameterValue"
                (valueChange)="onParameterValueChange($event)"></kendo-dropdownlist>
        </div>
    </div>
    <div class="row">
        <div class="row-title">{{'general.relationship_type' | stringLiterals}} <span class="required-field">*</span>
        </div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                [data]="relationshipTypeList" [textField]="'name'" [valueField]="'id'"
                [value]="selectedRelationshipType" (valueChange)="onRelationshipTypeChange($event)">
            </kendo-dropdownlist>
        </div>
        <div class="checkbox-employment-body">
            <label class="checkbox-employment" tam-checkbox [(ngModel)]="isSearchByRelationship"
                (click)="getSearchRelationshipStatus($event)"
                [disabled]="isDisabledCheckEmployment">{{'dashboard.include_current_employment' |
                stringLiterals}}
            </label>
            <div class="icon" kendoTooltip position="top" tooltipClass="tooltip-adjust-right"
                [title]="'dashboard.include_current_employment_tip' | stringLiterals">
                <smart-icon name="info" class="notification">
                </smart-icon>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="row-title">{{'dashboard.entity_type' | stringLiterals}}</div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="entityTypeList"
                [textField]="'name'" [valueField]="'id'" [value]="selectedEntityType"
                (valueChange)="onEntityTypeChange($event)"></kendo-dropdownlist>
        </div>
    </div>
    <div class="row">
        <div class="row-title">{{'dashboard.display' | stringLiterals}}</div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="displayList"
                [textField]="'value'" [valueField]="'id'" [value]="selectedDisplay"
                (valueChange)="onDisplayChange($event)"></kendo-dropdownlist>
        </div>
    </div>
</div>